import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, Renderer2 } from '@angular/core';
import { TranslateDirective, TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';

import { APP_VERSION_TOKEN } from '@app-config';
import { IdentityServicesService } from '@auth';
import { NavigationHistoryService } from '@core';
import { SasShellComponent } from '@layout';
import { AppService } from '@services';
import { TranslationService } from '@translations';

const STYLESHEET = 'STYLESHEET';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        SasShellComponent
    ],
    providers: [IdentityServicesService, TranslateService, TranslatePipe, TranslateDirective, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
    private readonly version = inject(APP_VERSION_TOKEN);
    private readonly appService = inject(AppService);
    private readonly renderer = inject(Renderer2);
    private readonly navigationHistory = inject(NavigationHistoryService);
    private readonly _ = inject(TranslationService); // eagerly initialize translations

    ngOnInit() {
        this.navigationHistory.start();
        this.setupStyleSheet();
    }

    private setupStyleSheet() {
        const stylesheet = this.appService.getConfigurationRaw(STYLESHEET);

        if (stylesheet !== undefined && stylesheet !== null) {
            this.appService.loadStylesheet(`${stylesheet}?v=${this.version}`, this.renderer);
        }
    }
}
